(function() {
	'use strict';

	angular.module('stationFlightHandling').config(config);

	function config($stateProvider) {
		$stateProvider.state('stationFlightHandling', {
			url : '/station-flight-handling',
			views : {
				'stationFlightHandlingView' : {
					templateUrl : 'station-flight-handling/views/station-flight-handling.tpl.html',
					controller : 'StationFlightHandlingCtrl',
					controllerAs : 'stationFlightHandling'
				}
			}
		});
	}
}());

